import { useCallback } from 'react';
import confetti from 'canvas-confetti';

export function useConfetti() {
  const fireConfetti = useCallback(() => {
    // Fire multiple bursts for a more dramatic effect
    const count = 200;
    const defaults = {
      origin: { y: 0.7 },
      zIndex: 9999,
    };

    function fire(particleRatio: number, opts: confetti.Options) {
      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      });
    }

    // Multiple bursts with different configurations for a rich effect
    fire(0.25, {
      spread: 26,
      startVelocity: 55,
    });

    fire(0.2, {
      spread: 60,
    });

    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    });

    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    });

    fire(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }, []);

  const fireZapConfetti = useCallback(() => {
    // Custom confetti effect for zaps - lightning-themed
    const colors = ['#FFD700', '#FFA500', '#FF8C00', '#FFFF00', '#FFE135'];
    
    const defaults = {
      origin: { y: 0.6 },
      zIndex: 9999,
      colors,
      shapes: ['circle', 'square'] as confetti.Shape[],
      ticks: 200,
    };

    // Central burst
    confetti({
      ...defaults,
      particleCount: 100,
      spread: 70,
      startVelocity: 50,
    });

    // Left side burst
    setTimeout(() => {
      confetti({
        ...defaults,
        particleCount: 50,
        angle: 60,
        spread: 55,
        origin: { x: 0.2, y: 0.6 },
      });
    }, 100);

    // Right side burst
    setTimeout(() => {
      confetti({
        ...defaults,
        particleCount: 50,
        angle: 120,
        spread: 55,
        origin: { x: 0.8, y: 0.6 },
      });
    }, 100);

    // Follow-up sparkles
    setTimeout(() => {
      confetti({
        ...defaults,
        particleCount: 30,
        spread: 100,
        startVelocity: 30,
        decay: 0.95,
        scalar: 0.8,
      });
    }, 250);
  }, []);

  return {
    fireConfetti,
    fireZapConfetti,
  };
}
